import { render } from "./hero.vue?vue&type=template&id=956c1592"
import script from "./hero.vue?vue&type=script&lang=js"
export * from "./hero.vue?vue&type=script&lang=js"
script.render = render

export default script